import { useT } from '../../i18n';

/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ 30 Oct 2026 · ELTÉRÉS A JELENHEZ — today's value under a past day's tile.  │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * The mockup's `ttApplyDelta`: *MOST {value} ↑/↓/=* in muted text under the figure.
 *
 * ⚠️ 3 Nov 2026 · **the direction compares the RAW numbers, never the formatted text.** It used to
 * parse `1 383:48` and `−6 374 260 Ft` back into numbers, which broke the day a figure could also
 * read `172,98 nap` (`decisions.md` DU-1). A tile carries its `figure` beside its `value`; a tile
 * whose figure is `null` simply gets no arrow.
 *
 * ⚠️ The arrow is a glyph, so it is hidden and its meaning is said in words for a screen reader.
 */
export function KpiDelta({
  now,
  then,
}: {
  /** Today's tile: what it shows, and the number behind it. */
  readonly now: { readonly value: string; readonly figure: number | null } | undefined;
  /** The shown day's number. */
  readonly then: number | null;
}) {
  const t = useT();
  if (now === undefined) return null;
  const a = then;
  const b = now.figure;
  const direction =
    a === null || b === null || Math.abs(b - a) < 0.0001 ? 'same' : b > a ? 'higher' : 'lower';
  return (
    <div className="text-muted-foreground mt-1.5 flex items-center gap-1 text-[11px] tabular-nums">
      <span>{t('tt.now', { value: now.value })}</span>
      <span aria-hidden>{direction === 'same' ? '=' : direction === 'higher' ? '↑' : '↓'}</span>
      <span className="sr-only">
        {direction === 'same'
          ? t('tt.same')
          : direction === 'higher'
            ? t('tt.higher')
            : t('tt.lower')}
      </span>
    </div>
  );
}
